import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Home from "./pages/Home/Home";
import Informations from "./pages/Informations/Informations";
import IndexGraphique from "./pages/IndexGraphique/IndexGraphique";
import Error from "./pages/Error/Error";
import Header from "./containers/Header/Header";
import Footer from "./containers/Footer/Footer";
import Projet from "./pages/Projet/Projet";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/informations" element={<Informations />} />
          <Route path="/indexgraphique" element={<IndexGraphique />} />
          <Route path="/projets/:id" element={<Projet />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
